export const getStatus = (statusCode) => {
    switch (statusCode) {
        case 'NewApplication':
            return `New Application`;
        case 'AwaitingResponse':
            return `Awaiting approval`;
        case 'Approved':
            return '';
        case 'ChangesRequested':
            return `Some changes have been requested, please check your email for details.`;
        case 'Rejected':
            return `Your application has been rejected, please contact support for more information.`;
        default:
            return '';
    }
};
export const getTier = (tier) => {
    switch (tier) {
        case 'Tier1':
            return `Taster`;
        case 'Tier2':
            return `Essential`;
        case 'Tier3':
            return `Plus`;
        default:
            return '';
    }
};
export const getRole = (role) => {
    switch (role) {
        case 'ADMIN':
            return `Primary admin`;
        case 'MANAGER':
            return `Admin`;
        case 'CULTURAL_MANAGER':
            return `Access Coordinator`;
        case 'TEAM_MEMBER':
            return `Access coordinator`;
        default:
            return '';
    }
};
export const getInviteStatus = (status) => {
    switch (status) {
        case 'Invited':
            return 'Pending - invite sent';
        case 'Accepted':
            return 'Accepted';
        case 'Rejected':
            return 'Rejected';
        default:
            return '';
    }
};
